import React from 'react';
import {
  LuHand, LuMousePointer2, LuHexagon, LuFlag, LuStickyNote, LuType, LuImage,
} from 'react-icons/lu';

/**
 * NodePalette — the floating canvas toolbar (Mixpanel parity): pan / select tools
 * on the left, then the node types you can drop (Metric, Strategy, Note, Text,
 * Media). Clicking a node type adds one to the canvas.
 *
 * props: tool ('pan'|'select'), onToolChange(tool), onAdd(nodeType)
 */
const NODE_BUTTONS = [
  { type: 'metric', label: 'Metric', Icon: LuHexagon },
  { type: 'strategy', label: 'Strategy', Icon: LuFlag },
  { type: 'note', label: 'Note', Icon: LuStickyNote },
  { type: 'text', label: 'Text', Icon: LuType },
  { type: 'media', label: 'Media', Icon: LuImage },
];

export default function NodePalette({ tool = 'select', onToolChange, onAdd }) {
  const toolBtn = (name, Icon, title) => {
    const active = tool === name;
    return (
      <button
        type="button"
        title={title}
        aria-label={title}
        aria-pressed={active}
        onClick={() => onToolChange && onToolChange(name)}
        style={{
          width: 40, height: 40, borderRadius: 9, border: 'none', cursor: 'pointer',
          display: 'grid', placeItems: 'center',
          background: active ? '#EDEBFB' : 'transparent',
          color: active ? '#4f5ed1' : '#334155',
        }}
      >
        <Icon size={19} />
      </button>
    );
  };

  return (
    <div
      style={{
        position: 'absolute', bottom: 40, left: '50%', transform: 'translateX(-50%)',
        zIndex: 6, display: 'flex', alignItems: 'center', gap: 4,
        background: '#fff', border: '1px solid #E3E9F1', borderRadius: 16,
        boxShadow: '0 2px 6px rgba(15,26,43,0.08), 0 14px 40px rgba(15,26,43,0.14)',
        padding: '8px 14px', fontFamily: '"Open Sans", system-ui, sans-serif',
      }}
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: 2, justifyContent: 'center' }}>
        {toolBtn('pan', LuHand, 'Pan the canvas')}
        {toolBtn('select', LuMousePointer2, 'Select & move')}
      </div>

      <div style={{ width: 1, height: 48, alignSelf: 'center', background: '#E3E9F1', margin: '0 8px' }} />

      <div style={{ display: 'flex', gap: 2 }}>
        {NODE_BUTTONS.map(({ type, label, Icon }) => (
          <button
            key={type}
            type="button"
            title={`Add ${label}`}
            onClick={() => onAdd && onAdd(type)}
            style={{
              display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 6,
              minWidth: 62, padding: '10px 8px', borderRadius: 10, border: 'none',
              cursor: 'pointer', background: 'transparent', color: '#0F1A2B',
            }}
            onMouseEnter={(e) => { e.currentTarget.style.background = '#F3F5F9'; }}
            onMouseLeave={(e) => { e.currentTarget.style.background = 'transparent'; }}
          >
            <Icon size={20} strokeWidth={1.6} />
            <span style={{ fontSize: 12, fontWeight: 600 }}>{label}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
